import { ttuTypes } from '../constants';

const initialState = {
  questions: [],
  showData: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${ttuTypes.FETCH_QUESTIONS}_SUCCESS`:
      return {
        ...state,
        questions: action.result
      };

    case `${ttuTypes.SHOW_TTU}_SUCCESS`:
      return {
        ...state,
        showData: action.result
      };

    case `${ttuTypes.HIDE_TTU_WIDGET}`:
      return {
        ...state,
        showData: {
          ...state.showData,
          state: action.showState
        }
      };
    case `${ttuTypes.SHOW_TTU_CURTAIN}`:
      return {
        ...state,
        showData: {
          ...state.showData,
          showTTU: action.show
        }
      };
    default:
      return state;
  }
};
export default reducer;
